import { render, staticRenderFns } from "./EliminarUbicacion.vue?vue&type=template&id=4cfcf357"
import script from "./EliminarUbicacion.vue?vue&type=script&lang=js"
export * from "./EliminarUbicacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports